import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateDepartmentRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { updateDepartments } from '../../api/departments.api';
import { UpdateDepartmentRequestItem } from '../../types/request/department-request';

/**
 * Hook to update departments in bulk (create new, update existing).
 * Invalidates department queries and team member queries (which use departments as dropdown options).
 */
export const useUpdateDepartments = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: (departments: UpdateDepartmentRequestItem[]) => updateDepartments(departments),
    onSuccess: async () => {
      // Invalidate department and team member queries
      await invalidateDepartmentRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
